import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary, CookieBanner } from "@/components/shared";
import { routerBasename } from "@/lib/publicUrl";
import Landing from "@/pages/Landing";
import Configurator from "@/pages/Configurator";
import Admin from "@/pages/Admin";
import CategoryPage from "@/pages/CategoryPage";
import ServicePage from "@/pages/ServicePage";
import NotFound from "@/pages/NotFound";
import { PrivacyPage, CookiePage } from "@/pages/Legal";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter basename={routerBasename}>
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/preventivo" element={<Configurator />} />
            <Route path="/preventivo/:id" element={<Configurator />} />
            <Route path="/catalogo/:categoria" element={<CategoryPage />} />
            <Route path="/servizi/:slug" element={<ServicePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookie" element={<CookiePage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
        </ErrorBoundary>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
